export default {
      id: "arrowright-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrowright",
      toString: function () {
        return this.url;
      }
    }